// Generated by CoffeeScript 2.7.0
// ==============================================================================
// PROJECTS - ABOUT
// ==============================================================================
import $ from "jquery";

$(function() {
  var addClassInScrolling, setSlick, unSetSlick;
  // Use slick in order to implement carousel elements
  (setSlick = function() {
    var opt;
    opt = {
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
      adaptiveHeight: true
    };
    return $('#JS--about_carousel').slick(opt);
  })();
  unSetSlick = function() {
    if ($('#JS--about_carousel').hasClass('slick-initialized')) {
      return $('#JS--about_carousel').slick('unslick');
    }
  };
  // Set detecting resize event
  this.detectResize.addFunction('sp', setSlick);
  this.detectResize.addFunction('pc', unSetSlick);
  if ($('#JS--about_scroll').length) {
    $(window).on('load scroll', () => {
      var i, j, results;
      results = [];
      for (i = j = 1; j <= 10; i = ++j) {
        results.push(addClassInScrolling($('.merit-' + i), 'fade-in'));
      }
      return results;
    });
  }
  return addClassInScrolling = (target, className) => {
    var fadeInPosition, scrollPos, winHeight, winScroll, winWidth;
    winScroll = $(window).scrollTop();
    winHeight = $(window).height();
    winWidth = $(window).width();
    fadeInPosition = winWidth >= 768 && winWidth < winHeight ? 300 : winHeight / 2;
    scrollPos = winScroll + winHeight - fadeInPosition;
    if (target.offset().top < scrollPos) {
      return target.addClass(className);
    }
  };
});
